import { Routes } from '@angular/router';
import { AuthGuard } from './services/auth.guard';

export const routes: Routes = [
  {
    path: 'home',
    loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent),
  },
  {
    path: 'conceito',
    loadComponent: () => import('./pages/conceito/conceito.component').then(m => m.ConceitoComponent),
  },
  {
    path: 'comunidade',
    loadComponent: () => import('./pages/comunidade/comunidade.component').then(m => m.ComunidadeComponent),
  },
  {
    path: 'parcerias',
    loadComponent: () => import('./pages/parcerias/parcerias.component').then(m => m.ParceriasComponent),
  },
  {
    path: 'equipas',
    loadComponent: () => import('./pages/equipas/equipas.component').then(m => m.EquipasComponent),
  },
  {
    path: 'eventos',
    loadComponent: () => import('./pages/eventos/eventos.component').then(m => m.EventosComponent),
  },
  {
    path: 'amigos',
    loadComponent: () => import('./pages/amigos/amigos.component').then(m => m.AmigosComponent),
  },
  {
    path: 'classificacao',
    loadComponent: () => import('./pages/classificacao/classificacao.component').then(m => m.ClassificacaoComponent),
  },
  {
    path: 'webapp',
    loadComponent: () => import('./pages/webapp/webapp.component').then(m => m.WebappComponent),
  },
  {
    path: 'spots/:id',
    loadComponent: () => import('./pages/webapp/webapp.component').then(m => m.WebappComponent),
  },
  {
    path: 'post/:id',
    loadComponent: () => import('./pages/post-details/post-details.component').then(m => m.PostDetailsComponent),
    canActivate: [AuthGuard],
  },
  { path: 'about', redirectTo: 'home', pathMatch: 'full' },
  {
    path: 'privacy-policy',
    loadComponent: () => import('./pages/privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent),
  },
  {
    path: 'terms-of-service',
    loadComponent: () => import('./pages/terms-of-service/terms-of-service.component').then(m => m.TermsOfServiceComponent),
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: 'register',
    loadComponent: () => import('./pages/register/register.component').then(m => m.RegisterComponent),
  },
  {
    path: 'recover/password',
    loadComponent: () => import('./pages/recover-password/recover-password.component').then(m => m.RecoverPasswordComponent),
  },
  {
    path: 'teams',
    loadComponent: () => import('./pages/teams/teams.component').then(m => m.TeamsComponent),
  },
  {
    path: 'teams/ranking',
    loadComponent: () => import('./pages/teams/teams-ranking/teams-ranking.component').then(m => m.TeamsRankingComponent),
  },
  {
    path: 'team/:id',
    loadComponent: () => import('./pages/teams/team-details/team-details.component').then(m => m.TeamDetailsComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'team/create/:id',
    loadComponent: () => import('./pages/teams/team-create/team-create.component').then(m => m.TeamCreateComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'team/chat/:id',
    loadComponent: () => import('./pages/teams/team-chat/team-chat.component').then(m => m.TeamChatComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'profile/activities/:id',
    loadComponent: () => import('./pages/profile/profile-activities/profile-activities.component').then(m => m.ProfileActivitiesComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'profile/friends',
    loadComponent: () => import('./pages/profile/profile-friends/profile-friends.component').then(m => m.ProfileFriendsComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'profile/ranking',
    loadComponent: () => import('./pages/profile/profile-ranking/profile-ranking.component').then(m => m.ProfileRankingComponent),
  },
  {
    path: 'profile/personal/info',
    loadComponent: () => import('./pages/profile/profile-personal-info/profile-personal-info.component').then(m => m.ProfilePersonalInfoComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'profile/friend/chat/:chatId/:userId',
    loadComponent: () => import('./pages/profile/friend-chat/friend-chat.component').then(m => m.FriendChatComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'profile/authorities/:userId',
    loadComponent: () => import('./pages/profile/profile-authorities/profile-authorities.component').then(m => m.ProfileAuthoritiesComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'events',
    loadComponent: () => import('./pages/events/events.component').then(m => m.EventsComponent),
  },
  {
    path: 'event/details/:id',
    loadComponent: () => import('./pages/events/event-details/event-details.component').then(m => m.EventDetailsComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'event/create/update/:id',
    loadComponent: () => import('./pages/events/event-create-update/event-create-update.component').then(m => m.EventCreateUpdateComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'event/chat/:id',
    loadComponent: () => import('./pages/events/event-chat/event-chat.component').then(m => m.EventChatComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'user/invite/:target/:id',
    loadComponent: () => import('./pages/user-invite/user-invite.component').then(m => m.UserInviteComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'roles/management',
    loadComponent: () => import('./pages/roles-management/roles-management.component').then(m => m.RolesManagementComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'spotted/places',
    loadComponent: () => import('./pages/spotted-places/spotted-places.component').then(m => m.SpottedPlacesComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'quests',
    loadComponent: () => import('./pages/quests/quests-list/quests-list.component').then(m => m.QuestsListComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'quests/create/:id',
    loadComponent: () => import('./pages/quests/quest-create-update/quest-create-update.component').then(m => m.QuestCreateUpdateComponent),
    canActivate: [AuthGuard],
  },
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: '**', redirectTo: 'home', pathMatch: 'full' },
];
